import React, { memo } from 'react'
import tw from 'twin.macro'
import { GSIcon } from 'src/components/shared/GSIcon'
import { TableTabs } from 'src/components/shared/table/table-tabs/TableTabs'
import type { TableTabItem } from 'src/components/shared/table/table-tabs/TableTabs'
import { RefundStatus } from 'src/constants/payments-ops/enums'
import { refundStatusLabels } from 'src/constants/payments-ops/labels'

interface Props {
  selectedStatus: RefundStatus
  onChange(status: RefundStatus): void
}

const TAB_ORDER = [
  RefundStatus.Created,
  RefundStatus.InProgress,
  RefundStatus.Paid,
  RefundStatus.Failed,
]

const selectedIconCss = tw`text-primary-600`
const iconCss = tw`text-shades-1000`

/**
 * No counts: the backend has no count endpoint, so only the selected tab could show one, and it
 * appeared only after each load — the tabs jumped every time. The grid footer carries the total.
 */
const REFUND_TABS = TAB_ORDER.map((status): TableTabItem<RefundStatus> => {
  return {
    value: status,
    title: refundStatusLabels[status].label,
    dataTestId: `refunds-tab-${status}`,
    renderIcon: (selected: boolean) => {
      return (
        <GSIcon
          iconName="gs_arrows_repeat_right_left"
          size={20}
          css={selected ? selectedIconCss : iconCss}
        />
      )
    },
  }
})

const RefundTabsComponent = ({ selectedStatus, onChange }: Props) => {
  return (
    <TableTabs<RefundStatus> tabs={REFUND_TABS} selectedValue={selectedStatus} onClick={onChange} />
  )
}

export const RefundTabs = memo(RefundTabsComponent)
